(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-recommendations"]) return;
  try {
    
    function loadRecommendedProducts(){
        var productId = $("#product-item").data("id");
        var limit = 12;

        if($("#product-recommendations").length){
            var url = "/recommendations/products?section_id=main-product-recommendations&limit="+limit+"&product_id="+productId;
    
            if(debug){
                url += '&preview_theme_id='+themeid;
            }

            $.ajax({
                url: url,
                type: "GET",
                cache: false,
                success: function(data) { 
                    if(data.length > 120){
                        $("#product-recommendations").html(data);
                        $("#product-recommendations").removeClass("hide");
                        if(typeof innerLink == "object"){
                            var recommendedInnerLinks = $("#product-recommendations").find("[data-innerlink]");
                            if(recommendedInnerLinks.length){
                                innerLink.init(recommendedInnerLinks);
                            }
                        }
                        if($("#product-recommendations [data-slick]").length){
                            $("#product-recommendations [data-slick]").slick({
                                "speed": 1000,
                                "autoplay":false,
                                "arrows":false,
                                "dots":false,
                                "swipeToSlide": true,
                                "nextArrow": '<a class="slider__next" href="#"><i class="i  i--chevron-right"></i><span class="hide-visually">Next</span></a>',
                                "prevArrow": '<a class="slider__prev" href="#"><i class="i  i--chevron-left"></i><span class="hide-visually">Previous</span></a>',
                                  customPaging: function(slider, i) { return $('<span class="slider__pager__item"><span class="hide-visually">'+i + 1+'</span></span>'); }
                            });
                        }
                    }
                },
                error: function(xhr, textStatus, errorThrown){
                    console.log(textStatus+ " "+errorThrown);
                }
            });
        }
    }

    $(document).ready(function(){
        loadRecommendedProducts();
    }); 
    console.log("Loading Recommended Products..");

  } catch(e) { console.error(e); }
})();
})();
